/*
 * @Author: your name
 * @Date: 2021-03-30 10:30:04
 * @LastEditTime: 2021-05-14 09:19:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\router\modules\settled.js
 */
export default [
    {
        path: '/account/account-list',
        component: resolve => require(['../../views/account/account-list.vue'], resolve),
        meta: { title: '账号列表' }
    },
    {
        path: '/account/account-org-list',
        component: resolve => require(['../../views/account/account-org-list.vue'], resolve),
        meta: { title: '账号列表' }
    },
    {
        path: '/account/organization-list',
        component: resolve => require(['../../views/account/organization-list.vue'], resolve),
        meta: { title: '机构列表' }
    },
    {
        path: '/account/organization-list-branch',
        component: resolve => require(['../../views/account/organization-list-branch.vue'], resolve),
        meta: { title: '机构列表' } //分社
    },
    
    {
        path: '/account/adminAuthList',
        component: resolve => require(['../../views/account/adminAuthList.vue'], resolve),
        meta: { title: '新增管理员权限' }
    },
    {
        path: '/account/user-list',
        component: resolve => require(['../../views/account/user-list.vue'], resolve),
        meta: { title: '角色列表' }
    },
    {
        path: '/account/lndividualOrder',
        component: resolve => require(['../../views/account/lndividualOrder.vue'], resolve),
        meta: { title: '散客订单' }
    },
    {
        path: '/account/teamOrder',
        component: resolve => require(['../../views/account/teamOrder.vue'], resolve),
        meta: { title: '团队订单' }
    },
    {
        path: '/account/orgOrderList/lndividualOrder',
        component: resolve => require(['../../views/account/orgOrderList/lndividualOrder.vue'], resolve),
        meta: { title: '散客订单' }
    },
    {
        path: '/account/orgOrderList/teamOrder',
        component: resolve => require(['../../views/account/orgOrderList/teamOrder.vue'], resolve),
        meta: { title: '团队订单' }
    },
    {
        path: '/account/orgOrderList/outSystemHeadList',
        component: resolve => require(['../../views/account/orgOrderList/outSystemHeadList.vue'], resolve),
        meta: { title: '系统外订单' }
    },
]



// WEBPACK FOOTER //
// ./src/TASMini/router/modules/account.js